import axios from 'axios';

import { API as dashboard } from './Dashboard/apis';
import { API as party } from './Parties/apis';
import { API as product } from './Products/apis';
import { API as quotation } from './Quotations/apis';
import { API as salesroute } from './SalesRoutes/apis';
import { API as stats } from './Stats/apis';

export const API = {
  ...salesroute, // salesroute + questionnaire
  ...product, // product + commercial_product
  ...quotation, // quotation + loan
  ...party, // party + referential
  ...dashboard, // dashboard
  ...stats, // stats
};

/**
 * Fetch from API
 * @param {*} options
 * @returns axios async function
 */
export const fetchFromApi = options =>
  axios(options)
    .then(response => ({ response }))
    .catch(error => ({ error }));
